export const TaskClosingCodesService = {
  getData() {
    return [
      {
        id: 1,
        taskClosingCode: 'Шифр 1'
      },
      {
        id: 2,
        taskClosingCode: 'Шифр 2'
      },
      {
        id: 3,
        taskClosingCode: 'Шифр 3'
      },
      {
        id: 4,
        taskClosingCode: 'Шифр 4'
      },
      {
        id: 5,
        taskClosingCode: 'Шифр 5'
      },
      {
        id: 6,
        taskClosingCode: 'Шифр 6'
      },
      {
        id: 7,
        taskClosingCode: 'Шифр 7'
      },
      {
        id: 8,
        taskClosingCode: 'Шифр 8'
      },
      {
        id: 9,
        taskClosingCode: 'Шифр 9'
      },
      {
        id: 10,
        taskClosingCode: 'Шифр 10'
      },
      {
        id: 11,
        taskClosingCode: 'Шифр 11'
      },
      {
        id: 12,
        taskClosingCode: 'Шифр 12'
      },
      {
        id: 13,
        taskClosingCode: 'Шифр 13'
      },
      {
        id: 14,
        taskClosingCode: 'Шифр 14'
      },
      {
        id: 15,
        taskClosingCode: 'Шифр 15'
      },
      {
        id: 16,
        taskClosingCode: 'Шифр 16'
      },
      {
        id: 17,
        taskClosingCode: 'Шифр 17'
      },
      {
        id: 18,
        taskClosingCode: 'Шифр 18'
      },
      {
        id: 19,
        taskClosingCode: 'Шифр 19'
      },
      {
        id: 20,
        taskClosingCode: 'Шифр 20'
      },
      {
        id: 21,
        taskClosingCode: 'Шифр 21'
      },
      {
        id: 22,
        taskClosingCode: 'Шифр 22'
      },
      {
        id: 23,
        taskClosingCode: 'Шифр 23'
      },
      {
        id: 24,
        taskClosingCode: 'Шифр 24'
      },
      {
        id: 25,
        taskClosingCode: 'Шифр 25'
      },
      {
        id: 26,
        taskClosingCode: 'Шифр 26'
      },
      {
        id: 27,
        taskClosingCode: 'Шифр 27'
      },
      {
        id: 28,
        taskClosingCode: 'Шифр 28'
      },
      {
        id: 29,
        taskClosingCode: 'Шифр 29'
      },
      {
        id: 30,
        taskClosingCode: 'Шифр 30'
      }
    ];
  },

  getTaskClosingCodes() {
    return Promise.resolve(this.getData());
  }
};
